module.exports = __webpack_public_path__ + "media/images/DOD_SCA_original-958d5dd060db7bad17cf835e2261e80e.jpg";